export const SurveyAnswerTypes = {
  YesNo: "Yes/No",
  MCQ: "MCQ",
  Text: "Text",
  Dropdown: "Dropdown",
};
